module.exports = __webpack_public_path__ + "static/media/Currículo.6de40885.pdf";